import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import Home from "../views/Home.vue";
import Login from "../views/Login.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      is_root: true,
    },
    children: [
      {
        name: "Dashboard",
        path: "dashboard",
        meta: {
          icon: "tachometer-alt",
          permission: "DASHBOARD.READ",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/dashboard/Index.vue"),
      },
      {
        name: "Realtime Dashboard",
        path: "realtime-dashboard",
        meta: {
          icon: "tachometer-alt",
          permission: "REALTIME_DASHBOARD.READ",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/realtime-dashboard/Index.vue"),
        children: [
          {
            name: "Realtime Dashboard Index",
            path: "",
            meta: {
              icon: "tachometer-alt",
              permission: "REALTIME_DASHBOARD.READ",
            },
            component: () => import(/* webpackChunkName: "about" */ "../views/realtime-dashboard/Dashboard.vue"),
          },
          {
            name: "Realtime Dashboard Provider User",
            path: "provider/:providerId",
            meta: {
              icon: "tachometer-alt",
              permission: "REALTIME_DASHBOARD.READ",
            },
            component: () => import(/* webpackChunkName: "about" */ "../views/realtime-dashboard/ProviderUser.vue"),
          },
          {
            name: "Realtime Dashboard User Provider",
            path: "user/:userId",
            meta: {
              icon: "tachometer-alt",
              permission: "REALTIME_DASHBOARD.READ",
            },
            component: () => import(/* webpackChunkName: "about" */ "../views/realtime-dashboard/UserProvider.vue"),
          },
          {
            name: "Realtime Dashboard Suspect Users",
            path: "suspect",
            meta: {
              icon: "tachometer-alt",
              permission: "REALTIME_DASHBOARD.READ",
            },
            component: () => import(/* webpackChunkName: "about" */ "../views/realtime-dashboard/SuspectUser.vue"),
          },
        ],
      },
      {
        name: "Provider Status",
        path: "provider-status",
        meta: {
          icon: "user",
          permission: "PROVIDER.STATUS.READ",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/dashboard/ProviderStatus.vue"),
      },
      {
        name: "Players",
        path: "players",
        meta: {
          icon: "users",
          permission: "MASTER-USER.READ",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/user/Index.vue"),
        children: [
          {
            name: "Player List",
            path: "",
            meta: {
              icon: "users",
              permission: "OPERATOR.READ",
            },
            component: () => import(/* webpackChunkName: "about" */ "../views/user/ListV2.vue"),
          },
          {
            name: "Player Profile",
            path: ":id",
            meta: {
              icon: "user",
              permission: "OPERATOR.READ",
            },
            component: () => import(/* webpackChunkName: "about" */ "../views/user/Show.vue"),
            children: [
              {
                name: "Wallet Info",
                path: "",
                meta: {
                  icon: "wallet",
                  permission: "OPERATOR.READ",
                },
                component: () => import(/* webpackChunkName: "about" */ "../views/user/Wallet.vue"),
              },
              {
                name: "Player Affiliate Info",
                path: "affiliate",
                meta: {
                  icon: "handshake",
                  permission: "OPERATOR.READ",
                },
                component: () => import(/* webpackChunkName: "about" */ "../views/user/Affiliate.vue"),
              },
              {
                name: "Player Bet Limit",
                path: "bet-limit",
                meta: {
                  icon: "money-check-alt",
                  permission: "OPERATOR.READ",
                },
                component: () => import(/* webpackChunkName: "about" */ "../views/user/BetLimit.vue"),
              },
              {
                name: "Player Wallet Transaction",
                path: "wallet-transaction",
                meta: {
                  icon: "money-check-alt",
                  permission: "OPERATOR.READ",
                },
                component: () => import(/* webpackChunkName: "about" */ "../views/user/WalletTransaction.vue"),
              },
              {
                name: "Player Game Records",
                path: "game-transaction",
                meta: {
                  icon: "gamepad",
                  permission: "GAME.READ",
                },
                component: () => import(/* webpackChunkName: "about" */ "../views/user/GameRecord.vue"),
              },
              {
                name: "Player Config",
                path: "user-config",
                meta: {
                  icon: "money-bill",
                  permission: "OPERATOR.READ",
                },
                component: () => import(/* webpackChunkName: "about" */ "../views/user/Config.vue"),
              },
              {
                name: "Player Config V2",
                path: "user-configV2",
                meta: {
                  icon: "money-bill",
                  permission: "OPERATOR.READ",
                },
                component: () => import(/* webpackChunkName: "about" */ "../views/user/ConfigV2.vue"),
              },
              {
                name: "Player Login",
                path: "login-history",
                meta: {
                  icon: "money-bill",
                  permission: "USER.AUDIT",
                },
                component: () => import(/* webpackChunkName: "about" */ "../views/user/LoginHistory.vue"),
              },
              {
                name: "Commission Info",
                path: "commission-info",
                meta: {
                  icon: "money-bill",
                  permission: "USER.AUDIT",
                },
                component: () => import(/* webpackChunkName: "about" */ "../views/user/CommissionInfo.vue"),
              },
              {
                name: "Player Loyalty Info",
                path: "player-loyalty-info",
                meta: {
                  icon: "money-bill",
                  permission: "USER.AUDIT",
                },
                component: () => import(/* webpackChunkName: "about" */ "../views/user/LoyaltyInfo.vue"),
              },
              {
                name: "User Event",
                path: "user-event",
                // path: ":id",
                meta: {
                  icon: "calendar",
                  permission: "USER.AUDIT",
                },
                component: () => import(/* webpackChunkName: "about" */ "../views/event/UserEvent.vue"),
              },
              {
                name: "User Transaction Summaries",
                path: "user-transaction-summaries",
                // path: ":id",
                meta: {
                  icon: "calendar",
                  permission: "USER.READ",
                },
                component: () => import(/* webpackChunkName: "about" */ "../views/user/UserTransactionSummaries.vue"),
              },
            ],
          },
        ],
      },
      {
        name: "Bank Verify Config",
        path: "bank-verify-config",
        meta: {
          icon: "users",
          permission: "PAYMENT.UPDATE",
        },
        component: () => import("../views/bank-verify-config/bankVerifyConfig.vue"),
      },
      {
        name: "Game Rounds",
        path: "game-rounds",
        meta: {
          icon: "gamepad",
          permission: "GAME.READ.GAME_ROUNDS",
        },
        component: () => import("../views/game-rounds/GameRounds.vue"),
      },
      {
        name: "OTP List",
        path: "otp-list",
        meta: {
          icon: "mobile",
          permission: "USER.READ.OTP",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/otp/Index.vue"),
      },
      {
        name: "Tier Config",
        path: "tier-config",
        meta: {
          icon: "badge-check",
          permission: "TIER.READ",
        },
        component: () => import("../views/user/Tier.vue"),
      },
      {
        name: "Ticket Manager",
        path: "ticket-manager",
        meta: { icon: "money-check-alt", permission: "OPERATOR.READ.TICKET_MGMT", seperator: true },
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "about" */ "../views/ticket-manager/TicketManager.vue"),
          },
          {
            path: ":id",
            component: () => import(/* webpackChunkName: "about" */ "../views/ticket-manager/TicketManagerEdit.vue"),
          }
        ]
      },
      {
        name: "Activity Logs",
        path: "activity-logs",
        meta: { icon: "history", permission: "ACTIVITY_LOG.READ" },
        component: () => import(/* webpackChunkName: "about" */ "../views/user-information/ActivityLogs.vue"),
      },
      {
        name: "Stream",
        path: "stream",
        meta: {
          icon: "building",
          permission: "STREAM.READ",
          separator: true,
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/user/Index.vue"),
      },
      {
        name: "Streamer",
        path: "streamer",
        meta: {
          icon: "users",
          permission: "STREAM.STREAMER",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/stream/streamer.vue"),
      },
      {
        name: "Streaming",
        path: "streaming",
        meta: {
          icon: "users",
          permission: "STREAM.STREAMING",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/stream/streaming.vue"),
      },
      {
        name: "Stream Config",
        path: "streamConfig",
        meta: {
          icon: "wrench",
          permission: "STREAM.CONFIG",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/stream/stream-config.vue"),
      },
      {
        name: "Coupon",
        path: "coupon",
        meta: {
          icon: "building",
          separator: true,
          permission: "COUPON.READ",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/user/Index.vue"),
      },
      {
        name: "Coupon Condition",
        path: "coupon-conditions",
        meta: {
          icon: "users",
          permission: "COUPON.READ",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/coupon/CouponCondition.vue"),
      },
      {
        name: "Coupon",
        path: "coupon",
        meta: {
          permission: "COUPON.READ",
          is_hidden: true
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/coupon/Coupon.vue"),
      },
      {
        name: "Internal Deposit",
        path: "internalDeposit",
        meta: {
          icon: "wallet",
          permission: "PAYMENT_CONFIG.DEPOSIT.APPROVE",
          separator: true,
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/user/Index.vue"),
      },
      {
        name: "Assign Operator Topup",
        path: "internalDeposit/approve-operator",
        meta: {
          icon: "wallet",
          permission: "OPERATOR.READ.FINANCE_OPERATOR_APPROVE",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/internal-deposit/ApproveTopupOperator.vue"),
      },
      {
        name: "Assign User Topup",
        path: "internalDeposit/approve-user",
        meta: {
          icon: "wallet",
          permission: "PAYMENT_CONFIG.DEPOSIT.APPROVE",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/internal-deposit/ApproveTopupUser.vue"),
      },
      {
        name: "Finance",
        path: "finance",
        meta: {
          icon: "building",
          permission: "OPERATOR.READ.FINANCE",
          separator: true,
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/user/Index.vue"),
      },
      {
        name: "Live Transaction",
        path: "transaction",
        meta: {
          icon: "money-check-alt",
          permission: "OPERATOR.READ.FINANCE",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/finance/TransactionV2.vue"),
      },
      {
        name: "Commission",
        path: "transaction/deposit",
        meta: {
          icon: "piggy-bank",
          permission: "OPERATOR.READ.FINANCE_DEPOSIT",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/finance/DepositV2.vue"),
      },
      {
        name: "Deposit Transaction",
        path: "transaction/deposit-be-payment",
        meta: {
          icon: "piggy-bank",
          permission: "PAYMENT_CONFIG.DEPOSIT.PAGINATION",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/finance/DepositPaymentSwitching.vue"),
      },
      {
        name: "Withdraw Transaction",
        path: "transaction/withdraw-be-payment",
        meta: {
          icon: "wallet",
          permission: "PAYMENT_CONFIG.WITHDRAW.PAGINATION",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/finance/WithdrawPaymentSwitching.vue"),
      },
      {
        name: "Approve Topup",
        path: "transaction/approve-topup-be-payment",
        meta: {
          icon: "piggy-bank",
          permission: "OPERATOR.READ.FINANCE_APPROVE",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/finance/ApproveTopupV2.vue"),
      },
      {
        name: "Approve Payout",
        path: "transaction/approve-payout-be-payment",
        meta: {
          icon: "wallet",
          permission: "OPERATOR.READ.FINANCE_APPROVE",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/finance/ApprovePayoutV2.vue"),
      },
      {
        name: "Finance V1",
        path: "finance",
        meta: {
          icon: "building",
          permission: "OPERATOR.READ.FINANCE_OLD",
          separator: true,
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/user/Index.vue"),
      },
      {
        name: "Withdraw Transaction V1",
        path: "transaction/withdraw",
        meta: {
          icon: "wallet",
          permission: "OPERATOR.READ.FINANCE_OLD",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/finance/WithdrawV2.vue"),
      },
      {
        name: "Manual Deposit V1",
        path: "manual/deposit",
        meta: {
          icon: "piggy-bank",
          permission: "OPERATOR.READ.FINANCE_OLD",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/finance/ManualDeposit.vue"),
      },
      {
        name: "Manual Withdraw V1",
        path: "manual/withdraw",
        meta: {
          icon: "wallet",
          permission: "OPERATOR.READ.FINANCE_OLD",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/finance/ManualWithdraw.vue"),
      },
      {
        name: "Approve Topup V1",
        path: "transaction/approve-topup",
        meta: {
          icon: "piggy-bank",
          permission: "OPERATOR.READ.FINANCE_OLD",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/finance/ApproveTopup.vue"),
      },
      {
        name: "Approve Payout V1",
        path: "transaction/approve-payout",
        meta: {
          icon: "wallet",
          permission: "OPERATOR.READ.FINANCE_OLD",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/finance/ApprovePayout.vue"),
      },
      {
        name: "Payment",
        path: "payment",
        meta: {
          icon: "building",
          permission: "OPERATOR.UPDATE.FINANCE",
          separator: true
        },
        component: () => undefined,
      },
      {
        name: "Payment Config",
        path: "payment-config/config",
        meta: {
          icon: "building",
          permission: "OPERATOR.UPDATE.FINANCE",
        },
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/payment-config/PaymentConfig.vue"),
      },

      {
        name: "Payment Config V2",
        path: "payment-config/configV2",
        meta: {
          icon: "building",
          permission: "OPERATOR.UPDATE.FINANCE",
        },
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/payment-config/PaymentConfigV2.vue"),
      },
      {
        name: "Deposit Config",
        path: "payment-config/PaymentMultipleDepositConfig",
        meta: {
          icon: "building",
          permission: "PAYMENT_CONFIG.MULTIPLE.DEPOSIT",
        },
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/payment-config/PaymentMultipleDepositConfig.vue"),
      },
      {
        name: "Withdraw Config",
        path: "payment-config/WithdrawConfigV3",
        meta: {
          icon: "building",
          permission: "PAYMENT_CONFIG.WITHDRAW_CONFIG_V3",
        },
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/payment-config/WithdrawConfigV3.vue"),
      },
      {
        name: "Auto Deposit List",
        path: "payment-config/payment-deposit-tiering-config",
        meta: {
          icon: "building",
          permission: "PAYMENT_CONFIG.OPERATOR_PAYMENT_DEPOSIT_TIERING.CREATE",
        },
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/payment-config/PaymentDepositTieringConfig.vue"),
      },

      {
        name: "Auto Withdraw List",
        path: "payment-config/TierConfig",
        meta: {
          icon: "building",
          permission: "PAYMENT_CONFIG.TIER",
        },
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/payment-config/TierConfig.vue"),
      },
      // {
      //   name: "Loyalty",
      //   path: "loyalty",
      //   meta: {
      //     icon: "building",
      //     permission: "LOYALTY.UPDATE",
      //     separator: true,
      //   },
      //   component: () => undefined,
      // },
      // {
      //   name: "Loyalty Info",
      //   path: "loyalty/info",
      //   meta: {
      //     icon: "medal",
      //     permission: "LOYALTY.UPDATE",
      //   },
      //   component: () => import("../views/loyalty/LoyaltyInfo.vue"),
      // },

      {
        name: "Affiliate & Commission",
        path: "affiliate-sep",
        meta: {
          icon: "handshake",
          permission: "AFFILIATE.READ.AFFILIATE_COMMISSION",
          separator: true,
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/user/Index.vue"),
      },
      {
        name: "New Member",
        path: "new-member",
        meta: {
          icon: "user-plus",
          permission: "AFFILIATE.READ.NEW_MEMBER",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/affiliate/Index.vue"),
        children: [
          {
            name: "Affiliate List",
            path: "",
            meta: {
              icon: "handshake",
              permission: "AFFILIATE.READ.AFFILIATE_LIST",
            },
            component: () => import(/* webpackChunkName: "about" */ "../views/affiliate/List.vue"),
          },
          {
            name: "Affiliate Show",
            path: ":id",
            meta: {
              icon: "handshake",
              permission: "AFFILIATE.READ.AFFILIATE_LIST",
            },
            component: () => import(/* webpackChunkName: "about" */ "../views/affiliate/Show.vue"),
          },
        ],
      },
      {
        name: "Reconciled Members",
        path: "new-members-reconciled",
        meta: {
          icon: "user-plus",
          permission: "AFFILIATE.READ.RECONCILED_NEW_MEMBER",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/affiliate/NewMemberReconciled.vue"),
      },
      {
        name: "Affiliate Summary",
        path: "affiliate-summary",
        meta: {
          icon: "file-invoice-dollar",
          permission: "AFFILIATE.READ.AFFILIATE_SUMMARY",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/affiliate/Summary.vue"),
      },
      {
        name: "Affiliate Summary Carry Forward",
        path: "affiliate-summary-carry-forward",
        meta: {
          icon: "file-invoice-dollar",
          permission: "AFFILIATE.READ.AFFILIATE_SUMMARY",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/affiliate/SummaryV2.vue"),
      },
      {
        name: "Non-Affiliate Summary",
        path: "non-affiliate-summary",
        meta: {
          icon: "file-invoice-dollar",
          permission: "AFFILIATE.READ.NON_AFFILIATE_SUMMARY",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/affiliate/NonAffiliateSummaryV2.vue"),
      },
      {
        name: "Affiliate Payout",
        path: "affiliate-payout",
        meta: {
          icon: "handshake",
          permission: "AFFILIATE.APPROVE_PAYMENT",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/affiliate/AffiliatePayout.vue"),
      },
      {
        name: "Commission Summary",
        path: "commission-summary",
        meta: {
          icon: "trophy-alt",
          permission: "AFFILIATE.APPROVE_PAYMENT",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/affiliate/CommissionSummaryV2.vue"),
      },
      {
        name: "Commission Payout",
        path: "commission-payout",
        meta: {
          icon: "trophy-alt",
          permission: "AFFILIATE.APPROVE_PAYMENT",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/affiliate/CommissionPayoutV2.vue"),
      },
      {
        name: "Loyalty Settings",
        path: "loyalty-setting",
        meta: {
          icon: "building",
          permission: "LOYALTY.CONFIG",
          separator: true,
        },
        component: () => undefined,
      },
      {
        name: "Loyalty Config",
        path: "loyalty/config",
        meta: {
          icon: "wrench",
          permission: "LOYALTY.CONFIG",
        },
        component: () => import("../views/loyalty/Config.vue"),
      },
      {
        name: "Reward Category",
        path: "loyalty/reward-category",

        meta: {
          icon: "boxes-alt",
          permission: "LOYALTY.CONFIG",
        },
        component: () => import("../views/loyalty/Category.vue"),
      },
      {
        name: "Reward",
        path: "loyalty/reward",

        meta: {
          icon: "gifts",
          permission: "LOYALTY.CONFIG",
        },
        component: () => import("../views/loyalty/Reward.vue"),
      },
      {
        name: "Fortune Wheel Config",
        path: "loyalty/fortuneWheelConfig",
        meta: {
          icon: "wrench",
          permission: "LOYALTY.FORTUNE_CONFIG.GET",
        },
        component: () => import("../views/loyalty/fortuneWheelConfig.vue"),
      },
      {
        name: "Daily Chest Campaign",
        path: "loyalty/dailyChestCampaign",
        meta: {
          icon: "gifts",
          permission: "DAILY_CHEST.MANAGE",
        },
        component: () => import("../views/loyalty/DailyChestCampaign.vue"),
      },
      {
        name: "Loyalty",
        path: "loyalty",
        meta: {
          icon: "building",
          permission: "LOYALTY.UPDATE",
          separator: true,
        },
        component: () => undefined,
      },
      {
        name: "Loyalty Info",
        path: "loyalty/info",
        meta: {
          icon: "medal",
          permission: "LOYALTY.UPDATE",
        },
        component: () => import("../views/loyalty/LoyaltyInfo.vue"),
      },
      {
        name: "Reward Redemption",
        path: "loyalty/reward-redemption",

        meta: {
          icon: "person-carry",
          permission: "LOYALTY.UPDATE",
        },
        component: () => import("../views/loyalty/Redemption.vue"),
      },
      {
        name: "Point Request",
        path: "loyalty/point-request",
        meta: {
          icon: "medal",
          permission: "LOYALTY.UPDATE",
        },
        component: () => import("../views/loyalty/PointRequest.vue"),
      },
      {
        name: "Point Request History",
        path: "loyalty/point-request-history",
        meta: {
          icon: "medal",
          permission: "LOYALTY.UPDATE",
        },
        component: () => import("../views/loyalty/PointRequestHistory.vue"),
      },
      {
        name: "Website Settings",
        path: "website-setting",
        meta: {
          icon: "building",
          permission: "WEBSITE.CONFIG",
          separator: true,
        },
        component: () => undefined,
      },
      {
        name: "Banner",
        path: "banner",
        meta: {
          icon: "images",
          permission: "WEBSITE.CONFIG",
        },
        component: () => import("../views/website/Banner.vue"),
      },
      {
        name: "EVENT SETTING",
        path: "event-setting",
        meta: {
          icon: "images",
          permission: "QUEST.CONFIG",
          separator: true,
        },
        component: () => undefined,
      },
      {
        name: "Event Reward",
        path: "event/reward",
        meta: {
          icon: "gifts",
          permission: "QUEST_REWARD.READ",
        },
        component: () => import("../views/event/Reward.vue"),
      },
      {
        name: "Event",
        path: "event",
        meta: {
          icon: "calendar",
          permission: "QUEST_EVENT.READ",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/event/Index.vue"),
        children: [
          {
            name: "Event List",
            path: "",
            meta: {
              icon: "users",
              permission: "QUEST_EVENT.READ",
            },
            component: () => import(/* webpackChunkName: "about" */ "../views/event/Event.vue"),
          },
          {
            name: "Sub Event",
            // path: "",
            path: ":id",
            meta: {
              icon: "calendar",
              permission: "QUEST_EVENT.READ",
            },
            component: () => import(/* webpackChunkName: "about" */ "../views/event/SubEvent.vue"),
          },
        ],
      },
      // {
      //   name: "User Event",
      //   path: "event/user-event",
      //   meta: {
      //     icon: "calendar",
      //     permission: "WEBSITE.CONFIG",
      //   },
      //   component: () => import("../views/event/Index.vue"),
      //   children: [
      //     {
      //       name: "User Event List",
      //       path: "",
      //       meta: {
      //         icon: "users",
      //         permission: "OPERATOR.READ",
      //       },
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "about" */ "../views/event/UserEvent.vue"
      //         ),
      //     },
      //     {
      //       name: "User Sub Event",
      //       // path: "",
      //       path: ":id",
      //       meta: {
      //         icon: "calendar",
      //         permission: "WEBSITE.CONFIG",
      //       },
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "about" */ "../views/event/UserSubEvent.vue"
      //         ),
      //     },
      //   ],
      // },
      {
        name: "User Information",
        path: "user",
        meta: {
          icon: "users",
          permission: "USER.AUDIT",
          separator: true,
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/user/Index.vue"),
      },
      {
        name: "User Activity Logs",
        path: "user-activity-logs",

        meta: { icon: "history", permission: "USER.AUDIT" },
        component: () => import("@/views/user-information/UserActivityLogs.vue"),
      },
      {
        name: "Admin Activity Logs",
        path: "admin-activity-logs",
        meta: { icon: "history", permission: "USER.ADMIN_AUDIT" },
        component: () => import("@/views/user-information/AdminActivityLogs.vue"),
      },
      {
        name: "Username Update Requests",
        path: "username-update-requests",
        meta: { icon: "signature", permission: "USER.CHANGE_APPROVAL" },
        component: () => import("@/views/user-information/UsernameUpdateRequest.vue"),
      },
      {
        name: "Username Update History",
        path: "username-update-history",

        meta: { icon: "history", permission: "USER.AUDIT" },
        component: () => import("@/views/user-information/UsernameUpdateHistory.vue"),
      },
      {
        name: "Blacklisted Users",
        path: "user-blacklised",

        meta: { icon: "user-slash", permission: "BLACKLIST.LIST" },
        component: () => import("@/views/user-information/UserBlacklisted.vue"),
      },
      {
        name: "Report",
        path: "report",
        meta: {
          icon: "chart-line",
          permission: "REPORT.READ",
          separator: true,
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/user/Index.vue"),
      },
      {
        name: "Daily Report",
        path: "report/daily",
        meta: {
          icon: "chart-line",
          permission: "REPORT.DAILY.READ",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/report/Daily.vue"),
      },
      {
        name: "Payment Daily Report",
        path: "report/payment",
        meta: {
          icon: "chart-line",
          permission: "REPORT.PAYMENT.READ",
        },
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/report/Payment.vue"),
      },
      {
        name: "Payment Approval Report",
        path: "report/payment-approval",
        meta: {
          icon: "chart-line",
          permission: "PAYMENT_APPROVAL_REPORT.READ",
        },
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/report/PaymentApprovalReport.vue"),
      },
      {
        name: "Game Report",
        path: "report/game",
        meta: {
          icon: "chart-line",
          permission: "REPORT.GAME.READ",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/report/Game.vue"),
      },
      {
        name: "Player Report",
        path: "report/player",
        meta: {
          icon: "chart-line",
          permission: "REPORT.PLAYER.READ",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/report/Player.vue"),
      },
      {
        name: "Summary Report",
        path: "report/summary",
        meta: {
          icon: "chart-line",
          permission: "REPORT.SUMMARY.READ",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/report/Summary.vue"),
      },
      {
        name: "Game Ranking",
        path: "report/ranking",
        meta: {
          icon: "chart-line",
          permission: "REPORT.GAME_RANKING.READ",
        },
        component: () => import(/* webpackChunkName: "about" */ "../views/report/Ranking.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: "/",
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;

